import { useAuth } from '../contexts/AuthContext';
import { AdminDashboard } from '../pages/AdminDashboard';
import { ClientDashboard } from '../pages/Dashboard';

export const RoleBasedDashboard: React.FC = () => {
  const { user } = useAuth();

  if (user?.role === 'admin') {
    return <AdminDashboard />;
  }

  return <ClientDashboard />;
};

